/* ═══════════════════════════════════════════════════════════════
   ALTERLY — Studio Entry Point
   Base-path aware: supports an independent root or a future '/alterly/' mount.
   ═══════════════════════════════════════════════════════════════ */

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './styles/global.css';
import { App } from './App';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root DOM element #root not found.');
}

const configuredBase = import.meta.env.BASE_URL;
const routerBasename = configuredBase === '/' ? undefined : configuredBase.replace(/\/$/, '');

createRoot(rootElement).render(
  <StrictMode>
    <BrowserRouter basename={routerBasename}>
      <App />
    </BrowserRouter>
  </StrictMode>
);
